import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCalendarPlusIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M17.0007 3.0083c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H8.9873v-1c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H5.001c-1.6569 0-3 1.3431-3 3v12c0 1.6569 1.3431 3 3 3h9.0817c.5523 0 1-.4477 1-1s-.4477-1-1-1H5.001c-.5523 0-1-.4477-1-1v-7h16v2.0668c0 .5523.4477 1 1 1s1-.4477 1-1V7.0083c0-1.6569-1.3432-3-3-3h-2.0003v-1Zm3.0003 7v-3c0-.5523-.4477-1-1-1h-2.0003v1c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1H8.9873v1c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1H5.001c-.5523 0-1 .4477-1 1v3h16Z" clipRule="evenodd"/>
    <path fill="currentColor" d="M19 21h-1a1.0001 1.0001 0 0 1 0-2h1v-1a1.0001 1.0001 0 0 1 2 0v1h1a1.0001 1.0001 0 0 1 0 2h-1v1a1.0001 1.0001 0 0 1-2 0v-1Z"/>
  </SvgIcon>
}

export default LineCalendarPlusIcon
